import { create } from 'zustand';

export type ChartType = 'candle' | 'bar' | 'line' | 'area' | 'hlc' | 'dots' | 'heikin'

interface ChartState {
  timeframe: number
  chartType: ChartType
  livePrice: number
  basePrice: number
  bid: string
  ask: string
  contextMenuPrice: number | null
  setTimeframe: (tf: number) => void
  setChartType: (ct: ChartType) => void
  setLivePrice: (p: number) => void
  setBasePrice: (p: number) => void
  setBidAsk: (bid: string, ask: string) => void
  setContextMenuPrice: (p: number | null) => void
}

export const useChartStore = create<ChartState>((set) => ({
  timeframe: 5,
  chartType: 'candle',
  livePrice: 0,
  basePrice: 0,
  bid: '\u2014',
  ask: '\u2014',
  contextMenuPrice: null,
  setTimeframe: (tf) => set({ timeframe: tf }),
  setChartType: (ct) => set({ chartType: ct }),
  setLivePrice: (p) => set({ livePrice: p }),
  setBasePrice: (p) => set({ basePrice: p }),
  setBidAsk: (bid, ask) => set({ bid, ask }),
  setContextMenuPrice: (p) => set({ contextMenuPrice: p }),
}));
